/*
 * HappyAlert — single premium alert system for the whole app.
 *
 *   import HappyAlert from '../components/HappyAlert';      // imperative API
 *   import { HappyAlertHost, installAlertShim } from '../components/HappyAlert';
 */

import HappyAlert from './HappyAlert';

export { default as HappyAlertHost } from './HappyAlertHost';
export { default as installAlertShim } from './installAlertShim';
export { default as HappyAlertController } from './controller';
export { HappyAlert };
export default HappyAlert;
